import { FormField } from '@domgen/dgx-fe-forms/layout';

export interface CmsSignInForm {
  signInDetailsForm: {
    emailAddressField: FormField;
    passwordField: FormField;
  };
}
